<template>
    <div name="banner" class="banner">
        <div class="section-wrap">
            <div class="section section1">
                <div class="title-area">
                    <strong class="title">
                        바로돌봄
                    </strong>
                    <p class="sub-text">
                        의료 취약계층을 위한 국내 유일 비대면 진료 솔루션<br>보다 편하고 안전하게 전문 의료진의 케어를 받을 수 있도록
                    </p>
                </div>
                <img class="img" src="../../assets/pc_barocare/bg_image1.jpg" alt="바로돌봄">
                <img class="banner-mouse" src="../../assets/pc_barocare/img_mouse_arrow.png" alt="아래로 이동">
            </div>
            <div class="section section2">
                <div class="title-area">
                    <strong class="title">
                        바로돌봄
                    </strong>
                    <p class="sub-text">
                        의료 취약계층을 위한 국내 유일 비대면 진료 솔루션<br>보다 편하고 안전하게 전문 의료진의 케어를 받을 수 있도록
                    </p>
                </div>
                <img class="img" src="../../assets/pc_barocare/bg_image2.jpg" alt="바로돌봄">
                <img class="banner-mouse" src="../../assets/pc_barocare/img_mouse_arrow.png" alt="아래로 이동">
            </div>
            <div class="section section3">
                <div class="title-area">
                    <strong class="title">
                        바로돌봄
                    </strong>
                    <p class="sub-text">
                        의료 취약계층을 위한 국내 유일 비대면 진료 솔루션<br>보다 편하고 안전하게 전문 의료진의 케어를 받을 수 있도록
                    </p>
                </div>
                <img class="img" src="../../assets/pc_barocare/bg_image3.jpg" alt="바로돌봄">
                <img class="banner-mouse" src="../../assets/pc_barocare/img_mouse_arrow.png" alt="아래로 이동">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'banner',
    data() {
        return {
            images: [
                require('../../assets/pc_barocare/bg_image1.jpg'),
                require('../../assets/pc_barocare/bg_image2.jpg'),
                require('../../assets/pc_barocare/bg_image3.jpg'),
            ],
            currentIndex: 0,
        };
    },
    mounted: function()
    {
        $('html').animate({
            scrollTop: 0
        }, 100);
        this.startImageSlider();

        $(window).scroll(function() {
            updateSections();
        });

        function updateSections() {
            var vhHeight = window.innerHeight / 100;
            var oneVh = 100 * vhHeight;
            var oneVhHeight = 100 * vhHeight - 500;
            var twoVhHeight = 200 * vhHeight - 500;
            var threeVhHeight = 300 * vhHeight - oneVh;
            var height = $(document).scrollTop();
            // console.log(height);

            if (height < oneVhHeight) {
                updateDisplay(['.section1'], ['.section2', '.section3'], 'on');
            } 
            else if (height >= oneVhHeight && height < twoVhHeight) {
                updateDisplay(['.section2'], ['.section1', '.section3'], 'on');
                $('.section1').removeClass('on');
            } 
            else if (height >= twoVhHeight && height < threeVhHeight) {
                updateDisplay(['.section3'], ['.section1', '.section2'], 'on');
                $('.section-wrap').removeClass('off');
            } 
            else if (height >= threeVhHeight + 0.1) {
                $('.section-wrap').addClass('off');
            }
        }

        function updateDisplay(showSelectors, hideSelectors, addClass) {
            $(showSelectors.join(', ')).css('display', 'inline-block').addClass(addClass);
            $(hideSelectors.join(', ')).css('display', 'none');
        }
    },
    methods: {
        goSign: function()
        {
            window.open('https://partner.soldoc.co.kr/', '_blank')
        },
        goFaq: function()
        {
            // $('html').animate({
            //     scrollTop: 8948
            // }, 300)
        },
        startImageSlider() {
            setInterval(() => {
                    this.currentIndex = (this.currentIndex + 1) % this.images.length;
                }, 4000);
        },
    },
}
</script>

<style scoped>
    .banner {
        position: relative;
        width: 100%;
        /* height: 1124px; */
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        z-index: 0;
    }

    .title-area{
        position: absolute;
        /* position: fixed; */
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding-top: 20px;
        z-index: 10;
        animation: fadeInUp1 1s;
    }
    .title {
        font-family: 'Pretendard';
        font-weight: 600;
        font-size: 70px;
        font-style: normal;
        text-align: center;
        line-height: 68px;
        color: #fff;
    }
    .sub-text{
        margin-top: 46px;
        font-family: 'Pretendard';
        font-style: normal;
        font-size: 22px;
        font-weight: 400;
        text-align: center;
        line-height: 1.5;
        color: #fff;
    }
    .image-slider {
        position: relative;
        width: 100%;
        height: 1124px;
        overflow: hidden;
    }

    .image-container {
        display: flex;
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .image-container img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        background-position: center center;
        opacity: 0;
        transition: opacity 1.2s;
    }
    .image-item.active {
        opacity: 1;
    }
    .banner-mouse{
        position: absolute;
        /* position: fixed; */
        left: 50%;
        bottom: 33px;
        transform: translate(-50%);
        display: block;
        width: 38px;
        height: 89px;
        z-index: 20;
    }

    .section-wrap{
        width: 100%;
        overflow: auto;
        height: 300vh;  
        overflow: hidden;
    }
    .section-wrap.off{
        overflow: inherit;
    }
    .section-wrap.off .section{
        position: relative;
        display: block !important;
    }
    .section{
        position: relative;
        display: block;
        width: 100%;
        height: 100vh;
        overflow: hidden;
    }
    .section.on{
        position: fixed;
        top: 0;
    }
    .section .img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(-50%, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translate3d(-50%, -50%, 0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare/Banner.vue